import { useMemo } from 'react'
import useLocalizeString from '../current-locale/use-localized-string'
import { ReservationF } from 'src/app/pages/booking/reservation-detail/types/reservation-detail.types'
import { ResourceOccupancyFragment } from '../../../api/api.generated'

export type NotSelectedOptionType = {
  id: 'NOT_SELECTED'
  notSelected: true
}

export type ReservedResourceOption =
  | {
      id: string
      index: number
      resourceType?: string
      assignedResourceType?: string
      resourceCode?: string
    }
  | NotSelectedOptionType

export function useReservedResourceOptions(reservation: ReservationF): ReservedResourceOption[] {
  const localizeString = useLocalizeString()
  return useMemo(() => {
    const rrs = reservation.reservedResources || []

    const rrOptions = rrs.map((rr, index) => {
      const occupancy = rr.currentResourceOccupancy as ResourceOccupancyFragment

      return {
        id: rr.id,
        index: index + 1,
        resourceType:
          occupancy.reservedResourceType.code ||
          (occupancy.reservedResourceType.customName && localizeString(occupancy.reservedResourceType.customName)) ||
          (occupancy?.reservedResourceType?.name?.description && localizeString(occupancy.reservedResourceType.name.description)),

        assignedResourceType:
          occupancy.assignedResourceType.code ||
          (occupancy.assignedResourceType.customName && localizeString(occupancy.assignedResourceType.customName)) ||
          (occupancy?.assignedResourceType?.name?.description && localizeString(occupancy.assignedResourceType.name.description)),

        resourceCode: occupancy?.resource?.code,
      }
    })

    const notSelectedOption: {
      id: 'NOT_SELECTED'
      notSelected: true
    } = {
      id: 'NOT_SELECTED',
      notSelected: true,
    }

    return [...rrOptions, notSelectedOption]
  }, [reservation])
}
